import {
    useRef,
    useState
} from 'react';

import {SimpleGrid} from '@mantine/core';

import {useMeters} from '../hooks/useMeters.ts';
import {useMetersSelection} from '../hooks/useMetersSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';
import {FormDrawer} from '../drawers/FormDrawer.tsx';
import {update} from '../services/MetersService.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";
import {Meter} from '../types';
import {useQueryClient} from '@tanstack/react-query';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useMetersSelection();
    const {columns} = useTableColumns();
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<Meter | null>(null);
    const queryClient = useQueryClient();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useMeters();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const handleDrawerSubmit = async (values: Meter) => {
        if (selectedRecord?.id) {
            const {created: _created, updated: _updated, createdByUsername: _createdByUsername, createdBy: _createdBy, ...rest} = values;
            await update(selectedRecord.id, rest as Meter);
            queryClient.invalidateQueries({queryKey: ['meters']});
        }
    };

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => {
                    setSelectedRecord(record);
                    setDrawerOpened(true);
                }}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>

            {drawerOpened && selectedRecord && (
                <FormDrawer
                    record={selectedRecord}
                    handleSubmit={handleDrawerSubmit}
                    opened={drawerOpened}
                    onClose={() => {
                        setDrawerOpened(false);
                        setSelectedRecord(null);
                    }}
                />
            )}
        </SimpleGrid>
    );
};
